import React, { useMemo, memo } from 'react'
import injectSheet from 'react-jss'
import styles from './slide.styles'
import Slide from '../../../components/slide/slide.jsx'
import { withPresentation } from '../../../presentation-connectors'
import Heading from '../../../components/heading/heading.jsx'
import SlideText from '../../../components/slide-text/slide-text.jsx'
import ScrollFade from '../../../components/scroll-fade/scroll-fade.jsx'

const VideoSlide = memo(({ classes, slides, id }) => {
  const data = slides[id]

  const slideData = useMemo(
    () => ({
      title: data.title,
      html: data.html_text,
      videoId: data.video.id
    }),
    [data]
  )

  return (
    <Slide className={classes.container}>
      <Heading className={classes.head}>{slideData.title}</Heading>
      <div className={classes.body}>
        <div className={classes.descHolder}>
          <SlideText contrast html={slideData.html} className={classes.desc} />
          <ScrollFade color="#25408f" />
        </div>
        <div className={classes.video}>
          <iframe
            className={classes.iFrame}
            id="ytplayer"
            type="text/html"
            allowFullScreen={true}
            src={`https://www.youtube.com/embed/${slideData.videoId}`}
            frameBorder="0"
          />
        </div>
      </div>
    </Slide>
  )
})

export default withPresentation(injectSheet(styles)(VideoSlide))
